import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Tooltip, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const AddKeywordButton = ({ to, state = undefined, title }) => {
  return (
    <Tooltip title={title} arrow placement="right">
      <Link to={to} state={state}>
        <IconButton
          size="sm"
          aria-label="add keywords"
          sx={{
            bgcolor: 'var(--color-btn-light)',
            '&:hover': {
              bgcolor: 'var(--color-primary)',
              color: 'var(--color-white)',
            },
          }}
        >
          <AddIcon
            sx={{
              fontSize: 'var(--font-size-m)',
            }}
          />
        </IconButton>
      </Link>
    </Tooltip>
  );
};

AddKeywordButton.propTypes = {
  to: PropTypes.string.isRequired,
  state: PropTypes.object,
  title: PropTypes.string.isRequired,
};

export default AddKeywordButton;
